<template>
    <div :class="groupClass">
        <div v-if="!fieldProduct || !fieldProduct.hide" class="row">
            <div :class="labelColClass">
                <field-label :fieldId="field.id" :label="field.label" :product="fieldProduct" :validator="validator" v-if="htmlField()===false" />
                <field-element :type="field.type" :text="field.label.value" v-if="htmlField()===true && field.label.value" />
                <field-element :type="field.type" :text="field.value" v-else-if="htmlField()===true" />
            </div>
            <div :class="fieldColClass" v-if="htmlField()===false">
                <component
                    :is="componentType"
                    :field="field"
                    :form="$store.state.form.formId"
                    :id="field.id"
                    :name="field.name"
                    :index="index"
                    :placeholder="field.placeholder"
                    :class="inputClass"
                    v-model="value"
                    v-on:filled-out="setValue($event)"
                    v-on:error="setEmittedError($event)"
                    :required="field.validator.required ? true : false"
                />
                <error-message v-if="error" :vuelidator="$v" :validator="validator"/>
                <error-message v-if="serverError" :serverMessage="serverMessage" :validator="validator" />
                <error-message v-if="emittedError" :serverMessage="emittedErrorMessage" :validator="validator" :vuelidator="$v"/>
                <field-description :description="field.description"/>
            </div>
        </div>
        <div v-else>
            <component
                :is="componentType"
                :field="field"
                :form="$store.state.form.formId"
                :id="field.id"
                :name="field.name"
                :index="index"
                :placeholder="field.placeholder"
                :class="inputClass"
                v-model="value"
                v-on:filled-out="setValue($event)"
                v-on:error="setEmittedError($event)"
                :required="field.validator.required ? true : false"
            />
        </div>
    </div>
</template>

<script>
  import { mapMutations, mapGetters, mapState } from 'vuex';
  import FieldLabel from './FieldLabel';
  import FieldDescription from './FieldDescription';
  import FieldElement from './FieldElement';
  import ErrorMessage from './ErrorMessage';
  import FieldValidation from '../models/FieldValidation';
  import formMixin from '../mixins/formMixin';
  import paymentsMixin from '../mixins/paymentsMixin';

  export default {
    mixins: [formMixin,paymentsMixin],
    data() {
      return {
        value: null,
        index: null,
        serverError: false,
        emittedError: false,
        serverMessage: '',
        emittedErrorMessage: '',
        schedulingDetails: {}
      };
    },
    props: {
        defaultValue: null
    },
    methods: {
      ...mapMutations({
        addField: 'addField',
        updateField: 'updateField',
        removeField: 'removeField',
        addError: 'addFieldError',
        updateError: 'updateFieldError',
      }),
      ...mapMutations('payments', {storePurchase: 'storePurchase', removePurchase: 'removePurchase', setTotal: 'setTotal'}),
      titleCase(string) {
        const result = string.replace(/([A-Z])/g, '$1');
        return result.charAt(0).toUpperCase() + result.slice(1);
      },
      typeClass(type, hidden) {
          let _class = type.replace('_', '').replace(/([A-Z])/g, '-$1').toLowerCase() + '-field-wrapper';
          if (hidden) {
              _class += '-hidden';
          }
          return _class;
      },
      setEmittedError(message) {
          this.emittedError = message ? true : false;
          this.emittedErrorMessage = message;
          this.storeError();
      },
      setValue(value) {
        this.value = value;
        this.$v.value.$touch();
        let purchaseValue = this.getPurchaseValues(this.field, value);
        if (purchaseValue) {
            if (purchaseValue.quantity == 0 || value == 0) {
                this.removePurchase(purchaseValue.id);
            } else {
                this.storePurchase(purchaseValue);
            }
            this.updateTotal();
        }
        this.storeError();
        this.storeResponse();
        this.$emit('form-field-value-set');
      },
      updateTotal() {
         this.setTotal(this.calcPurchaseTotal(this.purchases));
         this._storeResponse(this.totalField.id, {
           fieldId: this.totalField.id,
           fieldName: 'Total',
           value: this.calcPurchaseTotal(this.purchases),
         });
      },
      storeResponse() {
        if (!this.error) {
            this._storeResponse(this.field.id, this.response);
        }
      },
      _storeResponse(fieldID, response) {
        if (this.$store.getters.getFieldById(fieldID) == null) {
          this.addField(response);
        } else if (this.isProduct(fieldID) && this.qtyIsZero(response)) {
          this.removeField(response);
        } else {
          this.updateField(response);
        }
      },
      isProduct(fieldId) {
          let field = this.form.fields.find(field => field.id == fieldId);
          return field != null && field.integration_field_id == 'payments_SingleProduct';
      },
      qtyIsZero(response) {
          return response == null || response.value == 0;
      },
      storeError() {
        if (this.$store.getters.getFieldErrorById(this.field.id) == null) {
          this.addError(this.fieldError);
        } else {
          this.updateError(this.fieldError);
        }
      },
      htmlField() {
        return this.field.type=='h1'||this.field.type=='h2'||this.field.type=='h3'||this.field.type=='h4'||this.field.type=='h5'||this.field.type=='h6'||this.field.type=='p'?true:false;
      }
    },
    validations() {
      return new FieldValidation(this.validator, this.field).validationObject;
    },
    computed: {
      ...mapGetters('form', ['fieldById']),
      ...mapState('payments', { purchases: 'purchases' }),
      field() {
        return this.fieldById(this.$vnode.key);
      },
      componentType() {
        let type = `${this.titleCase(this.field.type.replace('_',''))}Field`;
        if (this.field.product && this.field.product.hide) {
            type += 'Hidden';
        }
        return type;
      },
      validator() {
        return this.field.validator || this.$helpers.nullValidator;
      },
      inputClass() {
        const ignoredTypes = [
            'radio',
            'checkbox',
            'checkboxes',
            'location',
            'teamMember',
            'service',
            'event',
            'schedulingDateAndTime',
            'payments_Checkbox',
            'payments_Radio',
            'payments_Dropdown'
        ];
        return {
          'form-control': !ignoredTypes.includes(this.field.type),
          'form-error': this.$v.$error,
        };
      },
      groupClass() {
        return {
          [this.field.integration]: true,
          [this.typeClass(this.field.type, this.field.product&&this.field.product.hide)]: true,
          "form-group": true,
          "col-lg-12": !this.field.customCssClass.match(/\bcol-/g),
          [this.field.customCssClass]: this.field.customCssClass
        }
      },
      labelColClass() {
        return {
            "col-lg-12": this.field.label && this.field.label.position=="top"||this.htmlField()===true,
            "col-lg-2" : this.field.label && this.field.label.position=="left",
            "madform-el-wrapper": this.htmlField()===true,
            "madform-label-wrapper": this.htmlField()===false
        }
      },
      fieldColClass() {
        return {
            "madform-field-wrapper": true,
            "col-lg-12": this.field.label.position=="top",
            "col-lg-10" : this.field.label.position=="left"
        }
      },
      error() {
        return this.$v.$error;
      },
      fieldError() {
        return {
          fieldId: this.field.id,
          error: this.$v.$error ? this.$v.$error : this.emittedErrorMessage,
        };
      },
      response() {
        return {
          fieldId: this.field.id,
          fieldName: this.field.name,
          value: this.value,
        };
      },
      fieldProduct() {
          return this.field.product ? this.field.product : {price:0};
      }
    },
    created() {
        if (this.defaultValue) {
            this.value = this.defaultValue;
        }
    },
    components: {
      FieldLabel,
      FieldDescription,
      ErrorMessage,
      FieldElement
    },
  };
</script>

<style>
    .hidden {
        display: none;
    }

    .form-control.form-error {
        border-color: #dc3545;
    }

    .payments-single-product-field-wrapper-hidden {
        display:none;
    }
</style>
